import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => {
  return <Spinner animation="border" />;
};
export default Loader;
